import { render, staticRenderFns } from "./SimpleTitle.vue?vue&type=template&id=1ed87837&"
import script from "./SimpleTitle.vue?vue&type=script&lang=js&"
export * from "./SimpleTitle.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports